export enum StorefrontWidgetType {
  InfoCard = "info_card",
  BothCheckoutButtons = "both_checkout_buttons",
  CheckoutButton = "checkout_button",
  CartCheckbox = "cart_checkbox",
  SingleToggle = "single_toggle",
  DoubleToggle = "double_toggle",
  CartCard = "cart_card",
  CheckoutCheckbox = "checkout_checkbox",
  PdpInfo = "pdp_info",
}
